import { render } from "./FormInputPhoneNumber.vue?vue&type=template&id=3c2e5f0e&ts=true"
import script from "./FormInputPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./FormInputPhoneNumber.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__